// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React components
import TransparentBlogCard from "examples/Cards/BlogCards/TransparentBlogCard";
import BackgroundBlogCard from "examples/Cards/BlogCards/BackgroundBlogCard";

const beneficios = [
  {
    image: "https://image4.cdnsbg.com/2/22/626410_1673918217512.jpg",
    title: "30% de descuento en anteojos recetados y ortopedia",
    description: "Se debe presentar, receta médica, ticket de compra y ultimo recibo de sueldo.",
    link: "https://wa.me/542645064476?text=Hola%20quiero%20solicitar%20el%20beneficio%20de%20descuento%20de%20anteojos%20para%20afiliados",
  },
  {
    image: "https://i.pinimg.com/1200x/d5/eb/b3/d5ebb382c557fc36e61242d3cce04942.jpg",
    title: "Camping complejo el Paraiso",
    description:
      "Descuento para  afiliados entrada con descuento solamente comprándola en el sindicato",
    link: "https://wa.me/542645064476?text=Hola%20quiero%20solicitar%20el%20beneficio%20de%20descuento%20de%camping%20para%20afiliados",
  },
  {
    image:
      "https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/blogs/31115/images/b0qlzF7SuOWwSVzq6Kiy_Atraer-clientes-a-tu-farmacia-1080x675.jpg",
    title: "Descuento en Red de farmacias Amparo",
    description: "30 % de descuento según Vademecum",
    link: "https://wa.me/542645064476?text=Hola%20quiero%20solicitar%20información%20del%20beneficio%20de%20descuento%20de%farmacia%20para%20afiliados",
  },
  {
    image: "https://i.pinimg.com/1200x/1e/ce/67/1ece67bdeffd4d227ad58a0aa68545f0.jpg",
    title: "Caja navideña",
    description:
      "En el mes de diciembre se entrega al Afiliado su caja navideña por sede sindical. Debera presentar el ultimo recibo de sueldo",
    link: "https://wa.me/542645064476?text=Hola%20quiero%20solicitar%20información%20del%20beneficio%20de%20caja%20navideña%20para%20afiliados",
  },
  {
    image: "https://i.pinimg.com/1200x/79/51/a7/7951a77e100d3e81d125dde6cfb7c1f5.jpg",
    title: "Descuento en estetica",
    description: "ESTETICA LILIANA BEATRIZ",
    link: "https://wa.me/542645064476?text=Hola%20quiero%20solicitar%20información%20del%20beneficio%20de%20estetica%20para%20afiliados",
  },
  {
    image: "https://i.pinimg.com/736x/5d/50/f0/5d50f0c7bd5500ec5ee9651a25f11a43.jpg",
    title: "Modulo Alimentario",
    description: "Entrega de modulos alimentarios para afiliados.",
  },
  {
    image: "https://i.pinimg.com/736x/31/fc/e6/31fce6b097fad257cd1a864278a88f76.jpg",
    title: "Entrega útiles escolares",
    description:
      "Deberá el afiliado presentar recibo de sueldo y libretas de los menores en edad escolar",
  },
  {
    image: "https://i.pinimg.com/736x/68/b8/b5/68b8b539cec4f0aadb13c92b8eecceb4.jpg",
    title: "Estetica Liliana Beatriz",
    description: "Descuentos exclusivos para afiliados",
    link: "https://wa.me/542645064476?text=Hola%20quiero%20solicitar%20información%20del%20beneficio%20de%20Estetica%20Liliana%20Beatriz",
  },
  {
    image: "https://i.pinimg.com/736x/b6/f9/15/b6f91556a48d43ccc61ff93e2b94b200.jpg",
    title: "Cabaña luz del Alma, Rodeo - San Juan",
    description: "Descuentos exclusivos para afiliados",
    link: "https://wa.me/542645064476?text=Hola%20quiero%20solicitar%20información%20del%20beneficio%20de%20Cabaña%20Luz%20del%20Alma",
  },
];

function Beneficios() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid container item xs={12} lg={6}>
          <MKTypography variant="h3" mb={6}>
            Beneficios
            <Typography>
              Importante!!! para acceder a cualquier beneficio se debe presentar DNI y ultimo recibo
              de sueldo
            </Typography>
          </MKTypography>
        </Grid>
        <Grid container spacing={3}>
          {beneficios.map((item, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Box
                sx={{
                  minHeight: 380,
                  "& h5": {
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  },
                }}
              >
                <TransparentBlogCard
                  image={item.image}
                  title={item.title}
                  description={item.description}
                  action={
                    item.link
                      ? {
                          type: "_blank",
                          route: item.link,
                          color: "info",
                          label: "Solicitar información",
                        }
                      : ""
                  }
                />
              </Box>
            </Grid>
          ))}
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          lg={3}
          sx={{
            paddingTop: "2rem",
          }}
        >
          <BackgroundBlogCard
            image={
              "https://scontent-scl3-1.xx.fbcdn.net/v/t39.30808-6/476560425_1044755241014329_1856705899251695247_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=cc71e4&_nc_eui2=AeEUihS7LTfMTW6s6aT0CTfLtdNwgNQMJO2103CA1Awk7Y7hKGA7eE9jEK6DKyp8PMxL4d1dtUgXaGjMejjxPSDK&_nc_ohc=tTuVMSFGD3UQ7kNvwEYoqcX&_nc_oc=AdlE7HJ898S5bErSmpkX34nRCtmRwNw-0CZawkJuYdeDewWGrtXrc0ukXzZneW83GE8&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=l_ZAYgEkTseC1isoihF9mQ&oh=00_AfkqL9sn6h6R6pggCAn-P7x6QadqeMM5M5Y8txzBYuNLAQ&oe=69364860"
            }
            title="Disfruta del verano"
            description="Relaja del trabajo y disfruta de un dia de familia en nuestro camping."
            action={{
              type: "internal",
              route: "/pages/blogs/author",
              label: "solicitar Vouchers",
            }}
          />
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Beneficios;
